import { CaratteristichePadreNode, PaginaNode } from '@gql/graphql'
import { CardSwiper, CertificationGrid, GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './CertificazioniHubTemplate.module.sass'
import useTrans from '@hooks/useTrans'

interface Props {
  pagina?: PaginaNode
  certificazioni?: CaratteristichePadreNode[]
  paginaParent?: PaginaNode
}

const CertificazioniHubTemplate = (props: Props) => {
  const { pagina = undefined, certificazioni = [], paginaParent } = props
  const t = useTrans()

  const correlatiItem = {
    name: t('Sostenibilità'),
    ctaLabel: t('Scopri di più sulla Sostenibilità'),
    url: paginaParent?.url,
    children: paginaParent?.menuChildren
      ? paginaParent.menuChildren
          .filter((x) => x.pk !== pagina.pk)
          .map((x) => ({
            ...x,
            name: x.nome,
            description: x.descrizione,
            image: x.previewImage,
          }))
      : [],
  }

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <CertificationGrid certificazioni={certificazioni} />
        <CardSwiper
          id="sostenibilita-correlati-swiper"
          item={correlatiItem}
          theme="neutral10"
          size="md"
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default CertificazioniHubTemplate
